import { call, put } from "redux-saga/effects";
import {
  addNewPhysicalInventory,
  editPhysicalInventory,
  deletePhysicalInventory,
} from "../../app/components/InventoryManagement/PhysicalInventory/helper/physicalInventoryHelper";
import {
  addNewPhysicalInventorySuccessAction,
  editPhysicalInventorySuccessAction,
  deletePhysicalInventorySuccessAction,
} from "./actions";

export function* addNewPhysicalInventorySaga(payload) {
  try {
    const response = yield call(
      addNewPhysicalInventory,
      payload.physicalInventoryData
    );
    yield put(addNewPhysicalInventorySuccessAction(response.data));
  } catch (err) {}
}

export function* editPhysicalInventorySaga(payload) {
  try {
    const response = yield call(
      editPhysicalInventory,
      payload.physicalInventoryData
    );
    yield put(editPhysicalInventorySuccessAction(response.data));
  } catch (err) {}
}

export function* deletePhysicalInventorySaga(payload) {
  try {
    const response = yield call(
      deletePhysicalInventory,
      payload.physicalInventoryData
    );
    yield put(deletePhysicalInventorySuccessAction(response.data));
  } catch (err) {}
}
